import OperatorApiRequest from "~/operatorApplication/ts/request/OperatorApiRequest";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import {ClientUserdataStore} from "~/operatorApplication/ts/store/ClientUserdataStore";

export default async function toggleClientPin(userdata: OperatorApplicationApi.OperatorApplicationClientOpenApiModel) {
    if (userdata.isPinned || !OperatorAccountStore.showFreeDialogForSite(userdata.siteId)) {
        let newValue = !userdata.isPinned;
        ClientUserdataStore.updateClient(() => {
            userdata.isPinned = newValue;
            return userdata;
        });
        let p: OperatorApplicationApi.OperatorBuddyListSetPinnedOpenApiModel = {
            username: userdata.username,
            pinned: newValue
        };
        let result = await (new OperatorApiRequest({
            url: "/buddyList/setPinned",
            p,
            silent: true
        })).send();
        if (result.showMessageOnError()) {
            ClientUserdataStore.updateClient(() => {
                userdata.isPinned = !newValue;
                return userdata;
            });
        }
    }
}